import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { graphql, useStaticQuery } from 'gatsby';

import { Link } from '../theme';
import AppStoreLinks from '../AppStoreLinks';

export function LanguageLink({ location }) {
  const isGermanEnv = process.env.CURRENT_LANGUAGE === 'de';

  return (
    <Link
      to={isGermanEnv ? `https://lets-foos.com${location}` : `https://komm-kickern.de${location}`}
      sx={(theme) => ({
        color: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        fontSize: theme.typography.pxToRem(16),
        // padding: '12px 0',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        [theme.breakpoints.up('sm')]: {
          marginRight: theme.spacing(4),
        },
      })}
    >
      <LanguageIcon style={{ marginTop: '-2px' }} /> {isGermanEnv ? 'en' : 'de'}
    </Link>
  );
}

LanguageLink.propTypes = {
  location: PropTypes.string.isRequired,
};

function Sidebar({ isOpen, toggleSidebar, location }) {
  const data = useStaticQuery(graphql`
    query {
      allStrapiHeaderMenu {
        nodes {
          menuLinks {
            DisplayTitle
            url
            id
          }
        }
      }
    }
  `);

  const navLinks = data.allStrapiHeaderMenu.nodes[0].menuLinks.slice(1, data.allStrapiHeaderMenu.length);
  return (
    <Box
      component="aside"
      sx={[
        (theme) => ({
          background: theme.palette.grey[900],
          display: 'flex',
          flexFlow: 'column nowrap',
          gap: 3,
          alignItems: 'center',
          opacity: 0,
          padding: '60px 0 40px',
          zIndex: 999,
          position: 'fixed',
          top: '78px',
          left: '0',
          height: 'auto',
          width: '100%',
          // placeItems: 'center',
          transition: 'all 0.3s linear',
          transform: 'translateX(200%)',
          [theme.breakpoints.up('sm')]: {
            transform: 'translateX(200%) !important',
          },
        }),
        isOpen && { opacity: 1, transform: 'translateX(0)' },
      ]}
    >
      {navLinks.map((link) => (
        <Link
          variant="inherit"
          underline="none"
          color="inherit"
          to={link.url}
          key={link.id}
          sx={(theme) => ({
            color: theme.palette.common.white,
            // display: 'block',
            fontSize: theme.typography.pxToRem(16),
            // padding: '12px 0',
            textAlign: 'center',
            textDecoration: 'none',
            textTransform: 'uppercase',
          })}
        >
          {link.DisplayTitle}
        </Link>
      ))}
      <LanguageLink location={location} />
      <AppStoreLinks />
    </Box>
  );
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  location: PropTypes.string.isRequired,
};

export default Sidebar;
